<template>
  <section>
    <div class="content-wrapper main-container">
      <question v-if="display"></question>
      <errors v-if="isVisibleErrorsModal"></errors>

      <div class="content-heading">
        Cancelled/Failed transactions
        <small data-localize="dashboard.WELCOME"></small>
      </div>

      <div class="row">
        <spinner v-if="loading"></spinner>
        <div class="col-lg-12">
          <div id="panelChart9" class="panel panel-default">

            <div class="panel-heading">
              <div class="panel-title">
                Transaction list
              </div>
            </div>
        <tabs>
          <tab name="Failed Transactions" :selected="true" >
             <FailedTransactionTabView
                :emptyTransactionsMessage="emptyTransactionsMessage"
                actionName="Archive"
                :transactions="transactions"
                :goToViewDetail="goToViewDetail"
                :handleArchiveUnarchiveTransaction="handleArchiveTransaction"
              />
          </tab>
          <tab name="Archived" >
              <FailedTransactionTabView
                :emptyTransactionsMessage="emptyArchivedTransactionsMessage"
                actionName="Unarchive"
                :transactions="archivedTransactions"
                :goToViewDetail="goToViewDetail"
                :handleArchiveUnarchiveTransaction="handleUnarchiveTransaction"
              />
          </tab>
        </tabs>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState,
  } from 'vuex';

  import _ from 'lodash';

  import tabs from '@/components/TabsComponent/Tabs';
  import tab from '@/components/TabsComponent/Tab';
  import Errors from '@/components/modals/Errors';
  import question from '@/components/modals/Question';
  import spinner from '@/components/widgets/Spinner';
  import FailedTransactionTabView from '@/components/FailedTransactionTabView';

  import {
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
    SET_USER,
    HIDE_QUESTION_MODAL,
    SHOW_QUESTION_MODAL,
  } from '@/store/mutation-types';


  export default {
    name: 'failedTransactionList',
    beforeMount() {
      this.getUserProfile().then((user) => {
        this.setUser(user);
      });
      this.loadTransactionsList();
    },
    components: {
      spinner,
      errors: Errors,
      tabs,
      tab,
      question,
      FailedTransactionTabView,
    },
    data() {
      return {
        transactions: [],
        archivedTransactions: [],
        transactionError: '',
        loading: false,
        emptyTransactionsMessage: 'There are no cancelled or failed transactions at the moment.',
        emptyArchivedTransactionsMessage: 'There are no archived transactions at the moment.',
      };
    },
    computed: {
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('question', [
        'display',
      ]),
    },
    methods: {
      ...mapActions('accountCreation', [
        'getUserProfile',
      ]),
      ...mapActions('transaction', [
        'getFailedCancelledTransactions',
        'updateTransaction',
      ]),
      ...mapMutations('app', {
        setUser: SET_USER,
      }),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
        showQuestionModal: SHOW_QUESTION_MODAL,
      }),
      async loadTransactionsList() {
        this.loading = true;
        try {
          const transactionsFailedAndCancelled = await this.getFailedCancelledTransactions();

          const [transactions, archivedTransactions] = _.partition(transactionsFailedAndCancelled,
                                                                       t => !t.archived);
          this.transactions = transactions;
          this.archivedTransactions = archivedTransactions;
        } catch (error) {
          if (error !== 'UNAUTHORIZED') {
            this.setErrorsModalInfo(['We could not retrieve transactions list']);
            this.showErrorsModal();
          }
        } finally {
          this.loading = false;
        }
      },
      goToViewDetail(transactionId) {
        this.$router.push({ name: 'FailedTransactionDetail', params: { id: transactionId } });
      },
      updateArchiveTransaction(transactionId, archived = false) {
        return this.updateTransaction({
          transactionId,
          payload: {
            archived,
          },
        }).then((response) => {
          this.loadTransactionsList();
          this.hideQuestionModal();
          return response;
        });
      },
      archiveTransaction(transactionId) {
        return this.updateArchiveTransaction(transactionId, true);
      },
      unarchiveTransaction(transactionId) {
        return this.updateArchiveTransaction(transactionId, false);
      },
      handleArchiveTransaction(transaction) {
        this.showQuestionModal({
          title: 'Archive Transaction',
          question: `Are you sure you want to archive the transaction ${transaction.transactionId}?`,
          method: () => {
            this.archiveTransaction(transaction.id);
          },
          yesButtonText: 'Confirm',
          hideCancelButton: false,
        });
      },
      handleUnarchiveTransaction(transaction) {
        this.showQuestionModal({
          title: 'Unarchive Transaction',
          question: `Are you sure you want to unarchive the transaction ${transaction.transactionId}?`,
          method: () => {
            this.unarchiveTransaction(transaction.id);
          },
          yesButtonText: 'Confirm',
          hideCancelButton: false,
        });
      },
    },
  };
</script>

<style scoped>
  .main-container {
    padding-top: 5;
  }

  .notes-list-title {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .content-heading {
    font-weight: normal;
  }

  .panel-default {
    padding: 20px 30px;
  }

  .panel-heading {
    color: #444;
    background-color: #ffffff;
    border-color: #cfdbe2;
    border-bottom: 0;
    font-size: 14px;
    padding: 25px 5px;
  }

  table {
    border-collapse: collapse;
  }

  th {
    padding: 14px 8px;
    color: #888;
    border-bottom-width: 1px;
    vertical-align: bottom;
    border-bottom: 1px solid #eee;
    border-top: 0;
    line-height: 1.52857143;
    font-weight: normal;
  }

  td {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  .table-striped>tbody>tr:nth-of-type(odd) {
    background-color: #fafbfc;
  }

</style>



// WEBPACK FOOTER //
// FailedTransactionList.vue?b6f064e6